export enum AutodataCustomEventTypes {
  ON_CLICK_RESULT = "onClickResultAutodata",
  ON_CLICK_SIMILAR_QUESTION = "onClickSimilarQuestionAutodata",
  ON_CLICK_USEFUL_QUESTION = "onClickUsefulQuestionAutodata",
  ON_CLICK_RESULT_WIDGET_LINK = "onClickResultWidgetLinkAutodata",
  ON_CLICK_ALL_RESULTS_WIDGET_LINK = "onClickAllResultsWidgetLinkAutodata",
  ON_ALGOLIA_REQUEST_SUCCESS = "onAlgoliaRequestSuccess",
}

export enum AutodataTrackingTypes {
  onClick = "onClick",
  collapsible = "collapsible",
  pageView = "pageView",
}

export interface DataEvent {
  category: string | null;
  action: string | null;
  label: string | null;
  value: string | number | null;
  faqThematic: string | null;
  faqCategory: string | null;
  faqQuestion: string | null;
  pageName?: string | null;
}

export type ClickResultEvent = CustomEvent<{
  dataEvent: DataEvent;
}>;

export type ClickSimilarQuestionEvent = CustomEvent<{
  dataEvent: DataEvent;
}>;

export type ClickUsefulQuestionEvent = CustomEvent<{
  dataEvent: DataEvent;
}>;

export type ClickResultWidgetLinkEvent = CustomEvent<{
  result: any;
  searchText: string;
}>;

export type AlgoliaRequestSuccessEvent = CustomEvent<{
  dataEvent: DataEvent;
}>;
